import MarkdownIt from "markdown-it";
import mila from "markdown-it-link-attributes";

const linkRenderer = new MarkdownIt("zero", {
    linkify: true,
})
    .use(mila, {
        attrs: {
            target: "_blank",
        },
    })
    .enable("linkify");

export default function renderLinks(input: string) {
    return linkRenderer.renderInline(input);
}
